import React from 'react';
import { Crisp } from "crisp-sdk-web"
import { useHistory } from 'react-router-dom';
import wordpressIcon from '../../assets/content/empty-state-wordpress-icon.svg'
import cmsIcon from '../../assets/content/empty-state-other-cms.svg'
import { ArrowRight, Headphones, MessageCircle } from 'lucide-react';
import { Card } from '../../components/ui/bootstrap';

function AudiosEmptyState({ orgId, integrationId }) {

    const history = useHistory();

    const INTEGRATIONS = [
        {
            icon: wordpressIcon,
            label: 'WordPress',
            sublabel: 'Auto-publish audio for every post using the Listen2It plugin.',
            action: () => history.push(`/organisation/${orgId}/integration/${integrationId}/wordpress`),
        },
        {
            icon: cmsIcon,
            label: 'Other CMS or Blog',
            sublabel: 'Add audio to any website or CMS with a universal embed snippet.',
            action: () => history.push(`/organisation/${orgId}/integration/${integrationId}/cms`),
        },
    ];

    return (
        <div className="d-flex flex-column gap-4">

            {/* Main card */}
            <Card className="p-5" shadow>

                {/* Centered hero */}
                <div className="text-center mb-5">
                    <div
                        className="d-inline-flex align-items-center justify-content-center rounded-4 mb-4"
                        style={{ width: 64, height: 64, background: 'rgba(var(--bs-primary-rgb),0.08)' }}
                    >
                        <Headphones size={28} color="var(--bs-primary)" strokeWidth={1.5} />
                    </div>
                    <p className="fw-bold text-body-emphasis mb-2" style={{ fontSize: 18 }}>
                        No audio articles yet
                    </p>
                    <p className="mb-0" style={{ fontSize: 14 }}>
                        Connect your content platform below to start auto-publishing audio, or upload an MP3 directly using the button above.
                    </p>
                </div>

                {/* Divider + section label */}
                <p className="fw-semibold text-body-emphasis mb-3" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
                    Connect a platform
                </p>

                {/* Integration rows */}
                <div className="d-flex flex-column gap-2">
                    {INTEGRATIONS.map((item, i) => (
                        <div
                            key={i}
                            className="d-flex align-items-center gap-3 rounded-3 p-3"
                            style={{
                                cursor: 'pointer',
                                border: '1px solid rgba(var(--bs-primary-rgb),0.1)',
                                background: 'rgba(var(--bs-primary-rgb),0.02)',
                                transition: 'background 0.15s',
                            }}
                            onClick={item.action}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(var(--bs-primary-rgb),0.06)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'rgba(var(--bs-primary-rgb),0.02)'}
                        >
                            <div
                                className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                                style={{ width: 40, height: 40, background: 'rgba(var(--bs-primary-rgb),0.06)' }}
                            >
                                <img alt={item.label} width={22} src={item.icon} />
                            </div>
                            <div className="flex-grow-1">
                                <p className="mb-0 fw-semibold text-body-emphasis" style={{ fontSize: 14 }}>{item.label}</p>
                                <p className="mb-0" style={{ fontSize: 12 }}>{item.sublabel}</p>
                            </div>
                            <ArrowRight size={15} style={{ color: 'var(--bs-body-color)', opacity: 0.4, flexShrink: 0 }} />
                        </div>
                    ))}
                </div>
            </Card>

            {/* Help strip */}
            <Card className="d-flex align-items-center gap-3 p-4">
                <div
                    className="d-flex align-items-center justify-content-center rounded-3 flex-shrink-0"
                    style={{ width: 38, height: 38, background: 'rgba(var(--bs-primary-rgb),0.08)' }}
                >
                    <MessageCircle size={18} color="var(--bs-primary)" strokeWidth={1.75} />
                </div>
                <div className="flex-grow-1">
                    <p className="mb-0 fw-semibold text-body-emphasis" style={{ fontSize: 13 }}>Need help getting started?</p>
                    <p className="mb-0" style={{ fontSize: 12 }}>Our team is ready to walk you through the setup.</p>
                </div>
                <button
                    className="btn btn-sm flex-shrink-0"
                    style={{
                        background: 'rgba(var(--bs-primary-rgb),0.08)',
                        border: '1px solid rgba(var(--bs-primary-rgb),0.2)',
                        color: 'var(--bs-primary)',
                        borderRadius: 50,
                        fontSize: 13,
                        padding: '5px 16px',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                    onClick={() => Crisp.chat.open()}
                >
                    Chat with us
                </button>
            </Card>
        </div>
    );
}

export default AudiosEmptyState;
